export interface WaitingRequest {id:string; name:string; expiresAt:number}
export class AdmissionClient {
  constructor(private readonly eventId:string, token:string, private readonly transport:typeof fetch=fetch, private readonly currentToken:()=>string|null=()=>token) {
    if (!/^(?:meet|room)-[a-f0-9]{32}$/.test(eventId)||!/^[A-Za-z0-9_.-]{20,8192}$/.test(token)) throw new Error('Sesiune invalidă.');
  }
  private async request(payload:Record<string,string>):Promise<any> {
    const transport=this.transport;
    const token=this.currentToken();
    if (!token) throw new Error('Sesiunea nu mai este disponibilă.');
    const response=await transport('https://app.vorbello.eu/admission-admin.php',{
      method:'POST',credentials:'omit',cache:'no-store',
      headers:{'Content-Type':'application/json',Authorization:`Bearer ${token}`},
      body:JSON.stringify({eventId:this.eventId,...payload})
    });
    const data=await response.json();
    if (!response.ok||data?.success!==true) throw new Error('Cererile de acces nu sunt disponibile.');
    return data;
  }
  async list():Promise<WaitingRequest[]> {
    const data=await this.request({action:'list'});
    if (!Array.isArray(data.requests)) throw new Error('Răspuns invalid.');
    return data.requests.map((request:any)=>{
      if (!request || typeof request.id!=='string'||!/^[a-f0-9]{32}$/.test(request.id)||
        typeof request.name!=='string'||request.name.length>160||!Number.isInteger(request.expiresAt)) throw new Error('Răspuns invalid.');
      return {id:request.id,name:request.name,expiresAt:request.expiresAt};
    });
  }
  async decide(requestId:string,decision:'approved'|'rejected'):Promise<void> {
    if (!/^[a-f0-9]{32}$/.test(requestId)||!['approved','rejected'].includes(decision)) throw new Error('Cerere invalidă.');
    await this.request({action:'decide',requestId,decision});
  }
}
